"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getPublicCDNLink = function getPublicCDNLink(url, appEnvUrl) {
  var _domainMap$defaultDom;
  var defaultDomain = appEnvUrl;
  var domainMap = {
    development: 'https://cdn-dev.lumirental.com',
    staging: 'https://cdn-staging.lumirental.com',
    production: 'https://cdn.lumirental.com'
  };
  var prefix = '/public/web';
  var finalDomain = (_domainMap$defaultDom = domainMap[defaultDomain]) !== null && _domainMap$defaultDom !== void 0 ? _domainMap$defaultDom : domainMap.staging;
  var fullUrl = finalDomain + prefix;
  return fullUrl + url;
};
var _default = exports["default"] = getPublicCDNLink;